export default __webpack_public_path__ + "static/books-6fc02174b07582ab2b4178bca6c010fe.jpeg";